import React from "react";
const HowItWorksSection = () => <section>hey i'm HowItWorksSection</section>;
export default HowItWorksSection;
